// @flow
'use strict';

import CamposNfse from './campos_nfse';

export default CamposNfse;